import { useEffect, useState } from 'react';
import axios from 'axios';
import { API } from '@/App';
import { Button } from '@/components/ui/button';
import { apiError } from './shared';

export const OperationsAccess = () => {
  const [admins, setAdmins] = useState([]);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(null);
  useEffect(() => { axios.get(`${API}/internal-staff/operations-admins`, { withCredentials: true }).then(r => setAdmins(r.data)).catch(e => setError(apiError(e))); }, []);
  const change = async admin => {
    setBusy(admin.user_id); setError('');
    try {
      const { data } = await axios.put(`${API}/internal-staff/operations-admins/${admin.user_id}`, { enabled: !admin.operations_manager }, { withCredentials: true });
      setAdmins(rows => rows.map(r => r.user_id === admin.user_id ? data : r));
    } catch (e) { setError(apiError(e)); } finally { setBusy(null); }
  };
  return <section className="divide-y" data-testid="operations-access-section">
    <h2 className="text-lg font-semibold py-4" data-testid="operations-access-heading">Responsables d’exploitation</h2>
    {error && <p role="alert" className="text-red-700 py-3" data-testid="operations-access-error">{error}</p>}
    {admins.map(admin => <div className="py-5 flex flex-wrap items-center justify-between gap-3" key={admin.user_id} data-testid={`operations-admin-${admin.user_id}`}>
      <div className="min-w-0"><p className="font-semibold break-words" data-testid={`operations-admin-name-${admin.user_id}`}>{admin.name}</p><p className="text-sm text-slate-600" data-testid={`operations-admin-status-${admin.user_id}`}>{admin.operations_manager ? 'Responsable d’exploitation · dispatchers uniquement' : 'Droits administrateur habituels'}</p></div>
      <Button variant={admin.operations_manager ? 'outline' : 'default'} disabled={Boolean(busy)} onClick={() => change(admin)} data-testid={`operations-admin-toggle-${admin.user_id}`}>{admin.operations_manager ? 'Retirer le poste' : 'Attribuer le poste'}</Button>
    </div>)}
  </section>;
};